<template>
  <Borde>
    <b-col
      cols="12"
      sm="10"
      md="7"
      xl="6"
      order="0"
      order-lg="4"
      class="d-flex align-items-center justify-content-center py-4 py-lg-5 mx-0 mx-sm-auto"
    >
      <div class="text-center">
        <div>
          <FontAwesomeIcon icon="exclamation-triangle" class="h2 text-danger" />
        </div>
        <div v-if="resultado" class="h3 text-danger font-weight-bold">Resultado inválido</div>
        <div v-else class="h3 text-danger font-weight-bold">Postulación inválida</div>
        <div class="d-block mt-4 font-weight-bold text-secondary">
          Verifique su postulación en el
          <router-link
            tag="button"
            :to="{ name: 'Sae' }"
            class="btn btn-lg btn-azul-oscuro2 d-block mt-1 px-auto px-lg-4 gilmer text-uppercase"
          >Sistema de Admisión Escolar</router-link>
        </div>
      </div>
    </b-col>
  </Borde>
</template>
<script>
import Borde from "@/components/generales/postulacion/Borde";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faExclamationTriangle);
export default {
  props: ["resultado"],
  components: {
    Borde,
    FontAwesomeIcon
  }
};
</script>


// WEBPACK FOOTER //
// src/components/generales/postulacion/Invalida.vue